import { Camera } from 'lucide-react';

/**
 * A soft, album-style grid of pet photos. Captions appear on the card; an
 * empty state invites the owner to add the first memory.
 */
export function PhotoGrid({ photos = [], emptyHint }) {
  const withUrl = photos.filter((p) => p && p.url);
  if (withUrl.length === 0) {
    return (
      <div className="rounded-portal bg-portal-card p-10 text-center shadow-portal">
        <Camera className="mx-auto h-9 w-9 text-portal-ink-faint" strokeWidth={1.5} />
        <p className="mt-3 text-portal-ink-muted">{emptyHint || 'Ancora nessuna foto. Aggiungi il primo ricordo.'}</p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {withUrl.map((photo, i) => (
        <figure
          key={photo.storageKey || photo.url || i}
          className="group overflow-hidden rounded-portal bg-portal-card shadow-portal"
        >
          <div className="aspect-square overflow-hidden">
            <img
              src={photo.url}
              alt={photo.caption || 'Foto'}
              loading="lazy"
              className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
            />
          </div>
          {photo.caption && (
            <figcaption className="px-3 py-2 text-sm text-portal-ink-muted">{photo.caption}</figcaption>
          )}
        </figure>
      ))}
    </div>
  );
}
